import { render, staticRenderFns } from "./ComplaintRegistration.vue?vue&type=template&id=ed4e3660"
import script from "./ComplaintRegistration.vue?vue&type=script&lang=js"
export * from "./ComplaintRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports